export default class BgSizeService {
    constructor() {
        BgSizeService.init()

        $(window).resize(() => {
            BgSizeService.init()
        })
    }

    static init() {
        const media = $('[data-element="strate-full-media"]')

        media.each(function () {
            const sizeDesktop = $(this).attr('data-bg-size-desktop'),
                sizeMedium = $(this).attr('data-bg-size-medium'),
                sizeSmall = $(this).attr('data-bg-size-small')

            if (window.matchMedia('(max-width: 650px)').matches) {
                $(this).attr('data-hc-bg', sizeSmall)
                $(this).css('background-image', 'url("' + sizeSmall + '")')
            } else if (window.matchMedia('(max-width: 1000px)').matches) {
                $(this).attr('data-hc-bg', sizeMedium)
                $(this).css('background-image', 'url("' + sizeMedium + '")')
            } else {
                $(this).attr('data-hc-bg', sizeDesktop)
                $(this).css('background-image', 'url("' + sizeDesktop + '")')
            }
        })
    }
}
